import { useState } from 'react';
import { Box } from '@mui/material';
import type { DeliveryCarrier, DeliveryPricingResponse } from '../utils/deliveryPricing';
import {
  getDeliveryCarrierBrand,
  resolveDeliveryCarrierLogoSrc,
} from '../utils/deliveryCarrierBranding';

type Props = {
  carrier: DeliveryCarrier;
  height?: number;
  maxWidth?: number;
  logoUrl?: string | null;
  /** Tarifs déjà chargés (messagerie) — évite un fetch XHR supplémentaire. */
  pricing?: DeliveryPricingResponse | null;
  locationProviderId?: number;
  sx?: object;
};

export default function DeliveryCarrierLogo({
  carrier,
  height = 32,
  maxWidth = 120,
  logoUrl,
  pricing,
  locationProviderId,
  sx,
}: Props) {
  const [imgError, setImgError] = useState(false);
  const brand = getDeliveryCarrierBrand(carrier);
  const src = imgError
    ? brand.src
    : resolveDeliveryCarrierLogoSrc(carrier, pricing, logoUrl, locationProviderId);

  return (
    <Box
      component="img"
      src={src}
      alt={brand.alt}
      onError={() => setImgError(true)}
      sx={{
        height,
        maxWidth,
        width: 'auto',
        objectFit: 'contain',
        display: 'block',
        flexShrink: 0,
        ...sx,
      }}
    />
  );
}
